import { ChipsideComponent } from "../chipside-component";

export class Tree extends ChipsideComponent {
	constructor() {
		super();

		this.identifier = this.getAttribute("identifier") ?? "";
		this.description = this.getAttribute("description") ?? "Tree view";

		this.classList.add("tree__wrapper");
	}

	parsedCallback() {
		const list = document.createElementWithContents("ul", null, {
			className: "tree",
			role: this.closest("chip-treeitem") ? "group" : "tree",
			ariaLabel: this.description
		});

		if (this.identifier) {
			list.id = this.identifier;
		}

		for (const item of [...this.children ?? []].filter(x => x.nodeName === "CHIP-TREEITEM")) {
			const listItem = document.createElementWithContents("li", item, {
				className: "tree-item",
				role: "treeitem"
			}), itemID = item.getAttribute("identifier") ?? "";

			if (itemID) {
				listItem.id = itemID;
			}

			list.appendChild(listItem);
		}

		this.appendChild(list);
	}
}